import React, { Component } from "react";
import man from "../assets/agent-reg-image.png";
import girl from "../assets/brand-reg-image.png";
import { NavBar } from "../components/ReusableElements";
import FormTemplate from "./RegistrationForm";

function SelectRegistrationType({ handleClick, ...props }) {
  return (
    <div className="home">
      <div className="reg-container">
        <h1 className="reg-title">Pick a registration type</h1>
        <div className="reg-options-container">
          <button className="reg-agent" onClick={() => handleClick("agent")}>
            <img src={man} alt="" height="auto" width="100%" />
            <body className="image-caption">Agent</body>
          </button>

          <button className="reg-brand" onClick={() => handleClick("brand")}>
            <img src={girl} alt="" height="auto" width="100%" />
            <body className="image-caption">Brand</body>
          </button>
        </div>
      </div>
    </div>
  );
}

export default class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      registrationType: null,
    };
  }

  handleClick(type) {
    this.setState({ registrationType: type });
  }

  render() {
    return (
      <div>
        <NavBar
          isLoggedIn={this.props.isLoggedIn}
          logout={this.props.toggleIsLoggedIn}
        />
        {this.state.registrationType === null ? (
          <SelectRegistrationType handleClick={this.handleClick.bind(this)} />
        ) : (
          <FormTemplate
            registrationType={this.state.registrationType}
            isLoggedin={this.props.isLoggedin}
          />
        )}
        <br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Registration.js